<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Reloj Checador</span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( puestos  , 'puestos')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-file</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row>

              <v-col cols="12" md="4" lg="2">
                <v-text-field
                  name="name"
                  label="Fecha"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="fechaini"
                  type="date"
                >
                </v-text-field>
              </v-col>


              <v-col cols="12" md="6">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>

              <v-col cols="12">
                {{ semana_formateada }}  
              </v-col>
            	
              <v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="puestos"
							    class="elevation-0"
							    :search="search"
							    :page.sync="page"
			            @page-count="pageCount = $event"
							    :mobile-breakpoint="100"
			            hide-default-footer
			            dense
							  >
                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.lunes="{ item }">
                    <v-chip 
                      v-if="item.lunes && !item.lunes_retardo"
                      color="green"
                      dark
                      @click="editItem(item.lunes_registro)"
                      small
                    >
                      Entrada
                    </v-chip>

                    <v-chip 
                      v-if="item.lunes && item.lunes_retardo"
                      color="orange"
                      dark
                      @click="editItem(item.lunes_registro)"
                      small
                    >
                      Retardo
                    </v-chip>

                    <v-chip 
                      v-if="!item.lunes"
                      color="red"
                      dark
                      small
                    >
                      Falta
                    </v-chip>
                  </template>


                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.martes="{ item }">
                    <v-chip 
                      v-if="item.martes && !item.martes_retardo"
                      color="green"
                      dark
                      @click="editItem(item.martes_registro)"
                      small
                    >
                      Entrada
                    </v-chip>

                    <v-chip 
                      v-if="item.martes && item.martes_retardo"
                      color="orange"
                      dark
                      @click="editItem(item.martes_registro)"
                      small
                    >
                      Retardo
                    </v-chip>

                    <v-chip 
                      v-if="!item.martes"
                      color="red"
                      dark
                      small
                    >
                      Falta
                    </v-chip>
                  </template>

                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.miercoles="{ item }">
                    <v-chip 
                      v-if="item.miercoles && !item.miercoles_retardo"
                      color="green"
                      dark
                      @click="editItem(item.miercoles_registro)"
                      small
                    >
                      Entrada
                    </v-chip>

                    <v-chip 
                      v-if="item.miercoles && item.miercoles_retardo"
                      color="orange"
                      dark
                      @click="editItem(item.miercoles_registro)"
                      small
                    >
                      Retardo
                    </v-chip>

                    <v-chip 
                      v-if="!item.miercoles"
                      color="red"
                      dark
                      small
                    >
                      Falta
                    </v-chip>
                  </template>

                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.jueves="{ item }">
                    <v-chip 
                      v-if="item.jueves && !item.jueves_retardo"
                      color="green"
                      dark
                      @click="editItem(item.jueves_registro)"
                      small
                    >
                      Entrada
                    </v-chip>

                    <v-chip 
                      v-if="item.jueves && item.jueves_retardo"
                      color="orange"
                      dark
                      @click="editItem(item.jueves_registro)"
                      small
                    >
                      Retardo
                    </v-chip>

                    <v-chip 
                      v-if="!item.jueves"
                      color="red"
                      dark
                      small
                    >
                      Falta
                    </v-chip>
                  </template>

                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.viernes="{ item }">
                    <v-chip 
                      v-if="item.viernes && !item.viernes_retardo"
                      color="green"
                      dark
                      @click="editItem(item.viernes_registro)"
                      small
                    >
                      Entrada
                    </v-chip>

                    <v-chip 
                      v-if="item.viernes && item.viernes_retardo"
                      color="orange"
                      dark
                      @click="editItem(item.viernes_registro)"
                      small
                    >
                      Retardo
                    </v-chip>

                    <v-chip 
                      v-if="!item.viernes"
                      color="red"
                      dark
                      small
                    >
                      Falta
                    </v-chip>
                  </template>

                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.sabado="{ item }">
                    <v-chip 
                      v-if="item.sabado && !item.sabado_retardo"
                      color="green"
                      dark
                      @click="editItem(item.sabado_registro)"
                      small
                    >
                      Entrada
                    </v-chip>

                    <v-chip 
                      v-if="item.sabado && item.sabado_retardo"
                      color="orange"
                      dark
                      @click="editItem(item.sabado_registro)"
                      small
                    >
                      Retardo
                    </v-chip>

                    <v-chip 
                      v-if="!item.sabado"
                      color="red"
                      dark
                      small
                    >
                      Falta
                    </v-chip>
                  </template>


							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.entrada="{ item }">
							      <v-chip 
							      	v-if="item.estado"
							      	small
							      	:color="item.estado == 1 ? 'green' : 'red'"
							      	dark
							      >
                      {{ item.entrada }}
                    </v-chip>
							    </template>

                  <template v-slot:item.fecha_registro="{ item }">
                    {{ item.fecha_registro ? item.fecha_registro.substr(0,10) : '' }}
                  </template>
							   
                  <template v-slot:item.entrada="{ item }">
                    <v-chip 
                      v-if="item.estado"
                      small
                      :color="item.estado == 1 ? 'green' : 'red'"
                      dark
                      @click="editItem(item, 1)"
                    >
                      {{ item.entrada }}
                    </v-chip>
                  </template>

                  <template v-slot:item.entrada_comida="{ item }">
                    <v-chip 
                      v-if="item.estado"
                      small
                      color="grey"
                      dark
                      @click="editItem(item, 2)"
                    >
                      {{ item.entrada_comida }}
                    </v-chip>
                  </template>

                  <template v-slot:item.salida_comida="{ item }">
                    <v-chip 
                      v-if="item.estado"
                      small
                      color="grey"
                      dark
                      @click="editItem(item, 3 )"
                    >
                      {{ item.salida_comida }}
                    </v-chip>
                  </template>

                  <template v-slot:item.salida="{ item }">
                    <v-chip 
                      v-if="item.estado"
                      small
                      color="grey"
                      dark
                      @click="editItem(item, 4)"
                    >
                      {{ item.salida }}
                    </v-chip>
                  </template>

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem2(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

                  <template v-slot:item.categoria_mikai="{ item }">
                    <div v-if="item.categoria_mikai && item.categoria_mikai == 1">Ausencia enferemadad</div>
                    <div v-if="item.categoria_mikai && item.categoria_mikai == 2">Vacaciones</div>
                    <div v-if="item.categoria_mikai && item.categoria_mikai == 3">Viajes</div>
                    <div v-if="item.categoria_mikai && item.categoria_mikai == 4">Servicio Técnico</div>
                  </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		  <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialogEditar"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.iddepartamentos }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-col cols="12">

            <v-tabs
              v-model="tab"
              align-with-title
              small
              dense
            >
              <v-tabs-slider color="primary"></v-tabs-slider>

              <v-tab>
                Entrada
              </v-tab>

              <v-tab>
                Entrada Comida
              </v-tab>

              <v-tab>
                Salida Comida
              </v-tab>

              <v-tab>
                Salida
              </v-tab>
            </v-tabs>


            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-card-text class="black--text" v-if="editedItem.entrada">
                    <b>Hora registro:</b> {{ editedItem.entrada.hora_registro }}
                  </v-card-text>
                  <v-card-text class="black--text" v-else>
                    <b>Hora registro:</b> No cuenta con una hora de registro
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text class="black--text" v-if="editedItem.entrada_comida">
                    <b>Hora registro:</b> {{ editedItem.entrada_comida.hora_registro }}
                  </v-card-text>
                  <v-card-text class="black--text" v-else>
                    <b>Hora registro:</b> No cuenta con una hora de registro
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text class="black--text" v-if="editedItem.salida_comida">
                    <b>Hora registro:</b> {{ editedItem.salida_comida.hora_registro }}
                  </v-card-text>
                  <v-card-text class="black--text" v-else>
                    <b>Hora registro:</b> No cuenta con una hora de registro
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text class="black--text" v-if="editedItem.salida">
                    <b>Hora registro:</b> {{ editedItem.salida.hora_registro }}
                  </v-card-text>
                  <v-card-text class="black--text" v-else>
                    <b>Hora registro:</b> No cuenta con una hora de registro
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>


          </v-col>

          <div id="map" style="height: 500px; width: 100%;"></div>
        </v-card-text>


        <v-card-actions>
          <v-btn
            color="red"
            dark
            dense
            rounded
            small
            @click="close"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="900px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Reporte de asistencias</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID: {{ editedItem.iddepartamentos }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headersReporte"
            :items="dataReporte"
            class="elevation-0"
            :search="search"
            :mobile-breakpoint="100"
            dense
          >
          </v-data-table>
        </v-card-text>


        <v-card-actions>
          <v-btn
            color="red"
            dark
            dense
            tile
            small
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogEditar2"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <label>Selecciona una clasificacion para este registro</label>
              <v-radio-group
                v-model="editedItem.categoria_mikai"
                column
              >
                <v-radio
                  label="Ausencia por Enfermadad"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Viajes"
                  :value="3"
                ></v-radio>
                <v-radio
                  label="Servicio Técnico"
                  :value="4"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row v-if="editedItem && editedItem.evidencias">
            <v-col cols="12" md="3" v-for="(img, i) in editedItem.evidencias" :key="i">
              <v-card class="py-4 shadowCard">
                <v-img :src="url + img.evidencia" contain aspect-ratio="2"></v-img>
              </v-card>
            </v-col>
          </v-row>

        </v-card-text>

        <v-card-actions>
          <v-btn
            color="red"
            dark
            dense
            tile
            small
            @click="dialogEditar2 = false"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            dark
            dense
            tile
            small
            @click="addReloj2( )"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el departamento?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  // import { Geolocation } from '@capacitor/geolocation';

  import L from "leaflet";


  export default {
  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],
    
    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
      	idpuestos:0,
      	puesto:'',
        iddepartamentos:0,
				fecha_creacion:null,
				deleted:null,
        categoria: 0
      },

      defaultItem: {
      	idpuestos:0,
      	puesto:'',
        iddepartamentos:0,
				fecha_creacion:null,
				deleted:null,
        categoria: 0
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      puestos: [],
      headers: [
        { text: 'Usuario'       , value: 'nomuser'         },
        { text: 'Puesto'        , value: 'puesto'          },
        { text: 'Departamento'  , value: 'departamento'    },
        { text: 'Lunes'         , value: 'lunes'           },
        { text: 'Martes'        , value: 'martes'          },
        { text: 'Miércoles'     , value: 'miercoles'       },
        { text: 'Jueves'        , value: 'jueves'          },
        { text: 'Viernes'       , value: 'viernes'         },
        { text: 'Sábado'        , value: 'sabado'          },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],
      departamentos:[],

      latitude:'',
      longitude:'',

      dialogEditar: false,
      fechaini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      map: null,

      categorias:[ 
        { id: 1, tipo : 'Entrada'},
        { id: 2, tipo : 'Entrada Comida'},
        { id: 3, tipo : 'Salida Comida'},
        { id: 4, tipo : 'Salida'},
      ],

      headersReporte:[],

      dialogEditar2: false,
      dataReporte  :[],
      url:'',
      dataReporte:[],
      semana_formateada:'',
      tab:null

    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar mi entrada' : 'Ver la entrada'
      },
    },

    watch: {
      dialog (val) {

        if( val ){
          // this.getCurrentPosition( )
        }
        val || this.close()

      },

      dialogEditar (val) {

        if( val ){
          this.initializeMap();
        }

        val || this.close()
      },


      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      this.url = this.$http.options.root + 'evidencia-reloj/'
      await this.initialize()
      await this.getDepartamentos( )
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.puestos = []

        const payload = {
          fechaini: this.fechaini,
        	fechafin: this.fechafin,
        	id: this.getdatosUsuario.id
        }

        return this.$http.post('reloj.checador', payload).then(response=>{
        	this.puestos           = response.body.usuariosReloj
          this.headersReporte    = response.body.headersReporte
          this.dataReporte       = response.body.dataReporte
          this.semana_formateada = response.body.semana_formateada
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getDepartamentos () {
      	this.cargar = true
        this.departamentos = []
        return this.$http.get('departamentos.list').then(response=>{
        	this.departamentos = response.body
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item ) {
        this.editedIndex = this.puestos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogEditar = true
		  },

      editItem2 (item ) {
        this.editedIndex = this.puestos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogEditar2 = true
      },

		  onDialogInput(isOpen) {
	      if (isOpen) {
	        // Espera un pequeño retraso para asegurarte de que el DOM esté completamente renderizado
	        this.$nextTick(() => {
	          this.initializeMap();
	        });
	      } else {
	        this.destroyMap();
	      }
	    },

		  initializeMap() {

		  	setTimeout(() => {
          this.initializeMap();
        }, 300);
		  	
	      // Evita inicializar múltiples veces
	      if (this.map) {
	        this.map.invalidateSize(); // Actualiza el tamaño del mapa
	        return;
	      }

        if( this.editedItem && this.editedItem.entrada && this.editedItem.entrada.lat ){
  	      // Inicializa el mapa
  	      this.map = L.map("map").setView([this.editedItem.entrada.lat, this.editedItem.entrada.lng], 13);

  	      // Agrega la capa de mapa base de OpenStreetMap
  	      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
  	        attribution:
  	          'Map data © <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
  	      }).addTo(this.map);

  	      // Añade un marcador
  	      L.marker([this.editedItem.entrada.lat, this.editedItem.entrada.lng])
  	        .addTo(this.map)
  	        .bindPopup("Ubicación seleccionada")
  	        .openPopup();
        }

	    },
	    destroyMap() {
	      // Elimina el mapa al cerrar el diálogo
	      if (this.map) {
	        this.map.remove();
	        this.map = null;
	      }
	    },

      async getCurrentPosition ( ){
        try {
          const coordinates = await Geolocation.getCurrentPosition();

          this.editedItem.lat  = coordinates.coords.latitude
          this.editedItem.lng  = coordinates.coords.longitude

          this.initializeMap();

        } catch (error) {
          console.error('Error getting location', error);
          return null;
        }
      },


      deleteItem (item) {
        this.editedIndex = this.puestos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      close () {
        this.dialog       = false
        this.dialogEditar = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      addReloj () {
	      this.cargar = true


        const payload = {

          lat : this.editedItem.lat,
          lng : this.editedItem.lng,
          id  : this.getdatosUsuario.id,
          categoria: this.editedItem.categoria
        }

        // Lo mandapos por el EP
        this.$http.post('reloj.checador.add', payload ).then(response=>{
          this.destroyMap();
          this.dialog = false
          this.dialogEditar = false
          this.close()
        	this.initialize()
        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })
      },

      addReloj2  () {
        this.cargar = true


        const payload = {
          id  : this.editedItem.id,
          lat : 0,
          lng : 0,
          id_trabajador  : this.getdatosUsuario.id,
          categoria_mikai : this.editedItem.categoria_mikai,
          fecha_registro : this.editedItem.fecha_registro
        }

        // Lo mandapos por el EP
        this.$http.post('reloj.checador.add.categoria', payload ).then(response=>{
          this.destroyMap();
          this.dialog = false
          this.dialogEditar = false
          this.dialogEditar2 = false
          this.close()
          this.initialize()
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },
    },
  }
</script>


<style>
	/* Asegúrate de incluir estilos de Leaflet */
	@import "leaflet/dist/leaflet.css";
</style>